import {Permissions, ErrorCode} from "./config";
import {General} from "./config";
import {eventBus} from "./main";

export const helperFunctions = {

    data(){
        return {
            canViewArticle: false,

        }
    },

    computed:{
        loggedUser:{
            get() {
                return this.$store.getters.loggedUser;
            },
            set(value){
                this.$store.dispatch('loggedUser', value);
            }
        },
        snackbarVisible: {
            get() {
                return this.$store.getters.getSnackbarVisible;
            },
            set(value) {
                this.$store.dispatch('setSnackbarVisible', value);
            }
        },
        snackbarText: {
            get() {
                return this.$store.getters.getSnackbarText;
            },
            set(value) {
                this.$store.dispatch('setSnackbarText', value);
            }
        },
        snackbarColor: {
            get() {
                return this.$store.getters.getSnackbarColor;
            },
            set(value) {
                this.$store.dispatch('setSnackbarColor', value);
            }
        },
        showMessageDialog: {
            get() {
                return this.$store.getters.getShowMessageDialog;
            },
            set(value) {
                this.$store.dispatch('setShowMessageDialog', value);
            }
        },
        messageDialogMessage: {
            get() {
                return this.$store.getters.getMessageDialogMessage;
            },
            set(value) {
                this.$store.dispatch('setMessageDialogMessage', value);
            }
        },
        confirmationDialogMessage: {
            get() {
                return this.$store.getters.getConfirmationDialogMessage;
            },
            set(value) {
                this.$store.dispatch('setConfirmationDialogMessage', value);
            }
        },
        showConfirmationDialog: {
            get() {
                return this.$store.getters.getShowConfirmationDialog;
            },
            set(value) {
                this.$store.dispatch('getConfirmationDialogLoading', value);
            }
        },
    },

    methods: {

        hasPermission(permissionId){
            let permissions = this.loggedUser.group.permissions;
            for(let i=0; i<permissions.length; i++){
                let permission = permissions[i];
                if(permission && permission.id === permissionId){
                    return true;
                }
            }
            return false;
        },

        isGroupAdmin(){
            return this.loggedUser.group.isAdmin;
        },

        isSuperAdminGroup(){
            try{
                return this.loggedUser.group.id === 1;
            }catch (e) {
                return false;
            }
        },

        showSnackBar(message, color){
            if (!message) return;
            this.snackbarText = message;
            this.snackbarColor = color;
            let timer = this.snackbarVisible ? 200 : 1;
            this.snackbarVisible = false;
            setTimeout(() => {
                this.snackbarVisible = true;
            }, timer);
        },

        messageDialog(message){
            this.messageDialogMessage = message;
            this.showMessageDialog = true;
        },

        confirmationDialog(message){
            this.confirmationDialogMessage = message;
            this.showConfirmationDialog = true;
        },

        handleErrorCodeMessage(response){
            this.consoleLog('responseMessage', response);

            let message = "";
            let color = "red";
            switch (response.error_code) {
                case ErrorCode.VALIDATION_FAILED:
                    if(response.showMessagebox){
                        this.messageDialog(response.description);
                    }else{
                        color = "red";
                        message = response.description;
                    }
                    break;

                case ErrorCode.NO_PERMISSION:
                    message = "Não tens a permissão necessária";
                    color = "blue";
                    break;

                case ErrorCode.ERROR:
                    message = "Ocorreu um erro. Por favor tente de novo";
                    break;

                default:
                    message = 'Ocorreu um erro!';
            }

            this.showSnackBar(message, color);
        },

        isOkFromServer(response){
            if(response.data.response === 'company_deactivated'){
                eventBus.$emit('onCheckIfOkFromServer', 'Sua empresa está de momento sem acesso a nhaFatura.', 'info');
                return false;
            }else if(response.data.response === 'maintenance_mode_on'){
                eventBus.$emit('onCheckIfOkFromServer', 'Estamos em manutenção por favor aguarde um pouco.', 'info');
                return false;
            }else if(response.data.response === 'notAuthorized'){
                eventBus.$emit('onCheckIfOkFromServer', 'Nao tens permissão.', 'info');
                return false;
            }
            return true;
        },

        consoleLog(message, val){
            if(General.APP_IN_DEVELOPMENT_MODE){
                if(!val){
                    console.log(message);
                }else{
                    console.log(message, val);
                }
            }
        },

        getGeneralEmployeePermissions(){
            return [
                Permissions.ARTICLE_VIEW, Permissions.ARTICLE_ADD, Permissions.ARTICLE_UPDATE,
                Permissions.CLIENT_VIEW, Permissions.CLIENT_ADD, Permissions.CLIENT_UPDATE,
                Permissions.PROVIDER_VIEW,
                Permissions.SELL_VIEW, Permissions.SELL_ADD,
                Permissions.INVOICE_PAYMENT, Permissions.INVOICE_RECEIPT_DELETE, Permissions.INVOICE_NOTA_DEBITO, Permissions.INVOICE_NOTA_CREDITO
            ]
        },

        getGeneralAdminPermissions(){
            return [
                Permissions.ARTICLE_VIEW, Permissions.ARTICLE_ADD, Permissions.ARTICLE_UPDATE, Permissions.ARTICLE_DELETE,
                Permissions.PROVIDER_VIEW, Permissions.PROVIDER_ADD, Permissions.PROVIDER_UPDATE, Permissions.PROVIDER_DELETE,
                Permissions.CLIENT_VIEW, Permissions.CLIENT_ADD, Permissions.CLIENT_UPDATE, Permissions.CLIENT_DELETE,
                Permissions.USER_VIEW, Permissions.USER_ADD, Permissions.USER_UPDATE, Permissions.USER_DELETE, Permissions.USER_CHANGE_PASS,
                Permissions.SELL_VIEW, Permissions.SELL_ADD,
                Permissions.PURCHASE_VIEW, Permissions.PURCHASE_ADD, Permissions.PURCHASE_UPDATE, Permissions.PURCHASE_DELETE,
                Permissions.INVOICE_PAYMENT, Permissions.INVOICE_RECEIPT_DELETE, Permissions.INVOICE_NOTA_DEBITO, Permissions.INVOICE_NOTA_CREDITO
            ]
        },

        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        roundToTwoDecimals(value){
            return (value/1).toFixed(2) / 1;
        },
        

        getSortBy(options){
            try{
                return options.sortBy[0];
            }catch (e) {
                return "";
            }
        },

        getSortDes(options){
            try{
                return options.sortDesc[0] ? "desc" : "asc";
            }catch (e) {
                return "";
            }
        }

    }
};